import React, {Component} from 'react';
import {Route, Routes} from 'react-router-dom';
import ReactGA from 'react-ga';

import './app.scss';
import BooksPage from "./containers/Books/BooksPage";
import Header from "./components/Header/Header";
import ContactPage from "./containers/ContactPage/ContactPage";
import './components/FontAwesomeIcons/LoadFontAwesomeIcons';
import ProjectsPage from "./containers/Projects/ProjectsPage";
import AboutPage from "./containers/AboutPage/AboutPage";
import NoMatchFourOhFourPage from "./containers/NoMatchFourOhFourPage/NoMatchFourOhFourPage";

class App extends Component {
    render() {
	    ReactGA.initialize('UA-52538190-1');
	    ReactGA.pageview(window.location.pathname + window.location.search);

	    return (
            <div className="App">
                <Header />

                <div className="container content">
                    <Routes>
                        <Route exact path='/' element={<AboutPage/>}/>
                        <Route exact path='/about' element={<AboutPage/>}/>
	                    	<Route exact path='/projects' element={<ProjectsPage/>}/>
                        <Route exact path='/books' element={<BooksPage/>}/>
                        <Route exact path='/contact' element={<ContactPage/>}/>
	                    <Route path='*' element={<NoMatchFourOhFourPage/>} />
                    </Routes>
                </div>
                <div className='extraSpace' />
            </div>
        );
    }
}

export default App;
